import React, {useState, useEffect} from "react";
import { useParams } from 'react-router-dom';
import {Helmet} from "react-helmet";
import Navigation from "../partials/Navigation";
import HorizontalNav from "../partials/Dashboard/HorizontalNav";
import hviCoverImg from "./../images/hvi-cover-img.jpg";
import GraTillGuldQuestions from "../partials/Dashboard/GraTillGuld/GraTillGuldQuestions";
import jobbet from "../partials/Dashboard/GraTillGuld/jobbet";
import myself from "../partials/Dashboard/GraTillGuld/myself";
import hemma from "../partials/Dashboard/GraTillGuld/hemma";
// import Tabs from 'react-bootstrap/Tabs';
// import Tab from 'react-bootstrap/Tab';
import jwt_decode from "jwt-decode";
import { useCookies } from "react-cookie";
import configVars from "../config";
import GraTillGuldResults from "../partials/Dashboard/GraTillGuld/GraTillGuldResults";
import { setWithExpiry } from '../common';
import TabContainer from 'react-bootstrap/TabContainer';
import TabContent from 'react-bootstrap/TabContent';
import TabPane from 'react-bootstrap/TabPane';
import { StickyContainer, Sticky } from 'react-sticky';

const GraTillGuld = () => {

    const [tabKey, setTabKey] = useState('jobbet');
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [jobAnswers, setJobAnswers] = useState([]);
    const [myselfAnswers, setMyselfAnswers] = useState([]);
    const [homeAnswers, setHomeAnswers] = useState([]);
    const [answered, setAnswered] = useState(false);
    const [userAnswers, setUserAnswers] = useState({});
    const [saving, setSaving] = useState(false);
    const { results } = useParams();
    // const colors = ['white', 'gray', 'bronze', 'silver', 'gold'];
    // const colorNames = ['', 'Grå', 'Brons', 'Silver', 'Guld'];

    const answerTypes = [
        {
            id: 'jobbet',
            title: 'J = Jobbet',
            color: 'jobb',
            questions: jobbet,
        },
        {
            id: 'myself',
            title: '& = Mig själv',
            color: 'secondary',
            questions: myself,
        },
        {
            id: 'hemma',
            title: 'H = Hemma',
            color: 'hemma',
            questions: hemma,
        },
    ];

    useEffect(() => {

        if ( results && results === 'results' ) {
            setAnswered( true );
            setUserAnswers(null);

        }

    }, [results]);

    const handleSaveData = async () => {

        if ( ! cookies.sustainyou_user_jwt ) return;

        setSaving( true );

        const jwtDecoded = jwt_decode(cookies.sustainyou_user_jwt);

        const dataObj = {
            'token': cookies.sustainyou_user_jwt,
            'answers': [
                {
                    'type': 'jobbet',
                    'ans': JSON.stringify( jobAnswers ),
                },
                {
                    'type': 'myself',
                    'ans': JSON.stringify( myselfAnswers ),
                },
                {
                    'type': 'hemma',
                    'ans': JSON.stringify( homeAnswers ),
                },
            ],
        }

        const formBody = Object.keys(dataObj).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(JSON.stringify(dataObj[key]))).join('&');

        let response = await fetch(
            `${configVars.apiUrl}sustainchange/v1/savegraytogold`,
            {
              method: "POST",
              headers: {
                Authorization: `Basic ${configVars.auth}`,
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
              },
              body: formBody,
            }
        );

        response = await response.json();

        if ( response ) {

            if ( response.success === true ) {
                setAnswered( true );
                setUserAnswers( response.data );
                setWithExpiry( `temp_g2g_user${jwtDecoded.id}`, response.data );
            }

        }

        setSaving( false );

    }

    return (
        <div className="main-wrapper">
            <Helmet>
				<title>Från grå till guld</title>
				<meta name="description" content="" />
			</Helmet>
			<Navigation />

            <div className="page-content-wrap">
                <HorizontalNav title="Från grå till guld" />

                <div className="pt-5 pt-lg-0 page-content-inner">
                    <div className="course-img-wrap d-flex overflow-hidden position-relative" style={{maxHeight: '300px',backgroundImage: `url(${hviCoverImg})`, backgroundSize: 'cover', backgroundPosition: 'center', height: '300px'}}>
						<div className="position-absolute w-100 h-100 top-0 left-0 dark-overlay d-flex justify-content-center align-items-center">
							<h1 className="text-white display-1 text-center text-shadow">Från grå till guld</h1>
						</div>
					</div>

                    <div className="px-4" style={{maxWidth: '1400px'}}>
                        <div className="hvi-wrap mt-5 ps-lg-4">

                            { answered &&
                                <GraTillGuldResults allData={userAnswers} />
                            }

                            { ! answered &&
                                <>
                                    <div className="mt-3 mb-6">
                                        <p>Här får du gå igenom olika delar i din vardag och värdera dem utifrån en fyrgradig skala: grå-brons-silver-guld. Var befinner jag mig idag?</p>
                                        <p>Tanken är inte att sträva efter guld i allt. Ibland behöver vi acceptera grå eller brons för att omständigheterna är sådana eller för att vi inte upplever det som särskilt viktigt. Syftet med skalan och graderingen är att göra dig medveten om hur din vardag ser ut.  </p>
                                        <p>Innehållet är indelat i J & H (Jobbet  - Mig själv - Hemma).</p>
                                        <p>Om något innehåll inte är relevant för dig hoppar du över det.</p>

                                        <div className="my-5">
                                            <div className="d-flex align-items-center mb-4">
                                                <div className="gtg-answer-wrap pe-3">
                                                    <div className="active gtg-answer rounded-circle bg-sy-gray text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium">Grå</div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <span className="h5 d-inline-block w-100 fw-bold">Dåligt/påståendet stämmer inte alls</span>
                                                    <span>Fungerar inte alls eller på ett sätt som som upplevs frustrerande och inte alls som jag önskar…</span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className="gtg-answer-wrap pe-3">
                                                    <div className="active gtg-answer rounded-circle bg-sy-bronze text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium">Brons</div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <span className="h5 d-inline-block w-100 fw-bold">Ok/påståendet stämmer delvis</span>
                                                    <span>Fungerar på ett sätt som känns neutralt, det har definitivt potential att bli bättre…</span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className="gtg-answer-wrap pe-3">
                                                    <div className="active gtg-answer rounded-circle bg-sy-silver text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium">Silver</div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <span className="h5 d-inline-block w-100 fw-bold">Bra/påståendet stämmer mestadels</span>
                                                    <span>Fungerar på ett sätt som får mig att må bra, som är bekvämt och som dessutom skänker mig glädje…</span>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center mb-4">
                                                <div className="gtg-answer-wrap pe-3">
                                                    <div className="active gtg-answer rounded-circle bg-sy-gold text-white d-flex align-items-center justify-content-center text-uppercase font-size-medium">Guld</div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <span className="h5 d-inline-block w-100 fw-bold">Bäst/påståendet stämmer helt</span>
                                                    <span>Fungerar på ett sätt som får mig att må toppen, det känns lyxigt och jag kan inte tänka mig något bättre…</span>
                                                </div>
                                            </div>
                                        </div>

                                        
                                    </div>

                                    <StickyContainer>

                                        <div className="question-tabs position-relative">

                                            <TabContainer activeKey={tabKey} onSelect={(k) => setTabKey(k)}>

                                                <Sticky disableCompensation>
                                                    
                                                    {({ style, isSticky }) => 
                                                        <div style={style} className={`${isSticky ? 'btns-is-sticky py-3' : ''} d-flex`}>

                                                            { answerTypes?.map( ( type, index ) => {

                                                                return (
                                                                    <div className={`d-flex flex-column result-tab position-relative align-items-center px-3 py-2 px-lg-5 py-lg-3 text-white bg-${type.color} me-2 me-lg-3 ${ tabKey === type.id ? 'active': ''}`} key={index} onClick={() => setTabKey(type.id)}>
                                                                        <span className="mb-2 h3">{type.title}</span>
                                                                    </div>
                                                                )
                                                                
                                                            })}
                                                        </div>
                                                    }
                                                </Sticky>
                                                
                                                <div className="gtg-summary border-top pt-3">

                                                    { answerTypes?.map( ( type, typeIndex ) => {
                                                                    
                                                        return (
                                                            <TabContent key={typeIndex}>
                                                                <TabPane eventKey={type.id}>
                                                                    { type.id === 'jobbet' &&
                                                                        <GraTillGuldQuestions qna={type.questions} answers={ (data) => setJobAnswers(data) } />
                                                                    }
                                                                    { type.id === 'myself' &&
                                                                        <GraTillGuldQuestions qna={type.questions} answers={ (data) => setMyselfAnswers(data) } />
                                                                    }
                                                                    { type.id === 'hemma' &&
                                                                        <GraTillGuldQuestions qna={type.questions} answers={ (data) => setHomeAnswers(data) } />
                                                                    }

                                                                </TabPane>
                                                            </TabContent>
                                                        )

                                                    })}

                                                </div>

                                            </TabContainer>

                                            {/* <Tabs activeKey={tabKey} className="mb-3 border-halite-blue" onSelect={(k) => setTabKey(k)}>
                                                <Tab eventKey="jobbet" title="J = Jobbet" tabClassName={`border-0 me-2 px-5 py-3 h4 text-white ${ tabKey === 'jobbet' ? 'bg-secondary': 'bg-halite-blue'}`}>
                                                    <GraTillGuldQuestions qna={jobbet} answers={ (data) => setJobAnswers(data) } />
                                                </Tab>
                                                <Tab eventKey="myself" title="& = Mig själv" tabClassName={`border-0 me-2 px-5 py-3 h4 text-white ${ tabKey === 'myself' ? 'bg-secondary': 'bg-halite-blue'}`}>
                                                    <GraTillGuldQuestions qna={myself} answers={ (data) => setMyselfAnswers(data)} />
                                                </Tab>
                                                <Tab eventKey="hemma" title="H = Hemma" tabClassName={`border-0  px-5 py-3 h4 text-white ${ tabKey === 'hemma' ? 'bg-secondary': 'bg-halite-blue'}`}>
                                                    <GraTillGuldQuestions qna={hemma} answers={ (data) => setHomeAnswers(data) } />
                                                </Tab>
                                            </Tabs> */}

                                            { ( jobAnswers.length > 0 || myselfAnswers.length > 0 || homeAnswers.length > 0 ) &&
                                                <button type="button" className="btn btn-primary position-absolute right-0 text-white top-0 rounded-pill gtg-save" onClick={ () => handleSaveData() }>
                                                    {saving &&
                                                        <div className="spinner-border text-light spinner-border-sm ms-2" role="status" >
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    }
                                                    {!saving &&
                                                        <i className="fa fa-floppy-o" aria-hidden="true"></i>
                                                    }
                                                    <span className="ms-2">Beräkna resultat</span>
                                                </button>
                                            }
                                        </div>

                                    </StickyContainer>

                                </>
                            }
                            

                        </div>
                    </div>
                </div>
            </div>

        </div>
    )

}

export default GraTillGuld;